// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

// The app layout still relies on full browser loads for top-level pages.
// Keep Turbo Frames available for focused panels, but do not let Turbo Drive
// intercept endpoint tab navigation or other full-page links.
Turbo.session.drive = false

window.writeClipboardText = function writeClipboardText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text || "")
  }

  return new Promise(function (resolve, reject) {
    const textarea = document.createElement("textarea")
    textarea.value = text || ""
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "-9999px"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      document.execCommand("copy") ? resolve() : reject(new Error("Copy failed"))
    } catch (error) {
      reject(error)
    } finally {
      document.body.removeChild(textarea)
    }
  })
}

window.setCopyButtonLabel = function setCopyButtonLabel(button, label) {
  if (!button) return

  const labelTarget = button.querySelector("[data-copy-label]")
  if (labelTarget) {
    labelTarget.textContent = label
  } else {
    button.textContent = label
  }
}

window.data = function data() {
    function getThemeFromLocalStorage() {
      // if user already changed the theme, use it
      if (window.localStorage.getItem('dark')) {
        return JSON.parse(window.localStorage.getItem('dark'))
      }

      // Default to light mode instead of following system preferences
      // This prevents the black screen issue on dashboard
      return false

      // Uncomment below to follow system dark mode preferences
      // return (
      //   !!window.matchMedia &&
      //   window.matchMedia('(prefers-color-scheme: dark)').matches
      // )
    }
  
    function setThemeToLocalStorage(value) {
      window.localStorage.setItem('dark', value)
    }
  
    return {
      dark: getThemeFromLocalStorage(),
      toggleTheme() {
        this.dark = !this.dark
        setThemeToLocalStorage(this.dark)
      },
      isSideMenuOpen: false,
      toggleSideMenu() {
        this.isSideMenuOpen = !this.isSideMenuOpen
      },
      closeSideMenu() {
        this.isSideMenuOpen = false
      },
      isNotificationsMenuOpen: false,
      toggleNotificationsMenu() {
        this.isNotificationsMenuOpen = !this.isNotificationsMenuOpen
      },
      closeNotificationsMenu() {
        this.isNotificationsMenuOpen = false
      },
      isProfileMenuOpen: false,
      toggleProfileMenu() {
        this.isProfileMenuOpen = !this.isProfileMenuOpen
      },
      closeProfileMenu() {
        this.isProfileMenuOpen = false
      },
      isPagesMenuOpen: false,
      togglePagesMenu() {
        this.isPagesMenuOpen = !this.isPagesMenuOpen
      },
      // Modal
      isModalOpen: false,
      trapCleanup: null,
      openModal() {
        this.isModalOpen = true
        this.trapCleanup = focusTrap(document.querySelector('#modal'))
      },
      closeModal() {
        this.isModalOpen = false
        this.trapCleanup()
      },
    }
  }
  
